import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=c3154a64&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3154a64')) {
      api.createRecord('c3154a64', component.options)
    } else {
      api.reload('c3154a64', component.options)
    }
    module.hot.accept("./Support.vue?vue&type=template&id=c3154a64&", function () {
      api.rerender('c3154a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/Support.vue"
export default component.exports